import { Component, Input, OnInit } from '@angular/core';
import { NextActionsService } from '@bo-client/shared/services/next-actions.service';
import { Observable } from 'rxjs';
import { NextActionDetails } from '@bo-client/shared/models/next-actions.dto';

@Component({
  selector: 'app-show-next-action-info',
  templateUrl: './show-next-action-info.component.html',
  styleUrls: ['./show-next-action-info.component.scss']
})
export class ShowNextActionInfoComponent implements OnInit {
  constructor(private nextActionsService: NextActionsService) {
    // empty
  }
  ngOnInit(): void {
    this.actionDetails$ = this.nextActionsService.getActionDetails$(this.action);
  }

  @Input() action: string;

  actionDetails$: Observable<NextActionDetails>;
}
